import React from 'react';
import styled from '@emotion/styled';
import { StyleColumn } from '../../../types/ColumnType';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import sv from 'dayjs/locale/sv';
import { ListingContact } from '@app/api/public/ContactsApi';
import { colors } from '../../../components/Shared/Style/colors';
import { margin } from '../../../components/Shared/Style/margin';
dayjs.locale(sv);

const Span = styled.span({
    textAlign: 'left',
});

const StyledNavLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
});

const StyledP = styled.p({
    color: colors.black80,
    marginTop: margin.s,
    fontSize: '12px',
});

export const COLUMNS: StyleColumn<ListingContact>[] = [
    {
        Header: 'Namn och mail',
        accessor: (value) => [value.email, value.name],
        width: 150,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const contact = row.original;
            return (
                <StyledNavLink to={`/contacts/${contact.id}`}>
                    <Span>{contact.name}</Span>
                    <StyledP>{contact.email}</StyledP>
                </StyledNavLink>
            );
        },
    },
    {
        Header: 'Roll',
        accessor: 'title',
        width: 200,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const contact = row.original;
            return (
                <StyledNavLink to={`/contacts/${contact.id}`}>
                    <Span>{contact.title}</Span>
                </StyledNavLink>
            );
        },
    },
    {
        Header: 'Telefon',
        accessor: 'phone_number',
        width: 200,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const contact = row.original;
            return (
                <StyledNavLink to={`/contacts/${contact.id}`}>
                    <Span>{contact.phone_number}</Span>
                </StyledNavLink>
            );
        },
    },

    {
        Header: 'Företag',
        accessor: 'company',
        width: 200,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const contact = row.original;
            return (
                <StyledNavLink to={`/contacts/${contact.id}`}>
                    <Span>{contact.company}</Span>
                </StyledNavLink>
            );
        },
    },
];

export const COLUMNSMOBILE: StyleColumn<ListingContact>[] = [
    {
        Header: 'Namn och mail',
        accessor: (value) => [value.email, value.name],
        width: 150,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const contact = row.original;
            return (
                <StyledNavLink to={`/contacts/${contact.id}`}>
                    <Span>{contact.email}</Span>
                </StyledNavLink>
            );
        },
    },
];
